module.exports = __webpack_public_path__ + "nclose_icon.svg";